export default __webpack_public_path__ + "static/media/nequi.b1ac59c8.svg";